import { render, staticRenderFns } from "./Game_CashOrderList.vue?vue&type=template&id=5236b56e&scoped=true&"
import script from "./Game_CashOrderList.vue?vue&type=script&lang=js&"
export * from "./Game_CashOrderList.vue?vue&type=script&lang=js&"
import style0 from "./Game_CashOrderList.vue?vue&type=style&index=0&id=5236b56e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5236b56e",
  null
  
)

export default component.exports